import { useMemo } from "react";
import { CameraTool } from "@treegram/tools-camera";
import { DrawVectorTool } from "@treegram/tools-draw-vector";
import { createViewerTool, ViewerTool } from "@/hooks/viewer/use-viewer.ts";

export const useOrganisationPlanTools = (): ViewerTool[] =>
    useMemo<ViewerTool[]>(() => [
        createViewerTool({
            key: "cameraTool",
            factory: (ctx) => new CameraTool(ctx.viewer),
            setup: (tool) => {
                tool.setNavigationMode("Plan");
            },
        }),
        createViewerTool({
            key: "drawVectorTool",
            factory: (ctx) => new DrawVectorTool(ctx.viewer),
        }),
    ], []);

export default useOrganisationPlanTools;
